<template>
  <TreeSelect
    :props="props"
    :options="departmentData"
    :accordion="isAccordion"
    @getValue="getValue($event)"
    :value="valueId"
    ref="treeSelect"
  ></TreeSelect>
</template>

<script>
import TreeSelect from "@/components/treeSelect/treeSelect.vue";
export default {
  created() {
    this.getDepartments();
  },
  components: {
    TreeSelect
  },
  data() {
    return {
      // 可清空（可选）
      isClearable: true,
      // 可收起（可选）
      isAccordion: true,
      // 初始Id
      valueId: "",
      departmentData: [],
      props: {
        value: "id",
        label: "departmentName",
        children: "children"
      }
    };
  },
  watch: {
    valueId: {
      handler(val) {
        this.$emit("byDepartmentId", val);
      },
      immediate: true
    }
  },
  methods: {
    getDepartments() {
      this.$api.getOrganizationAll().then(res => {
        this.departmentData = res;
      });
    },
    getValue(value) {
      this.valueId = value;
    },
    clearSelected() {
      this.$refs.treeSelect.clearHandle();
    }
  }
};
</script>

<style>
</style>